<template>
  <div class="welcome">
    <h1>Welcome to Unmatched Maker!</h1>
    <b-row>
      <b-col lg="4" order-lg="2">
        <div class="welcome">
          <p>
            <a href="https://restorationgames.com/unmatched/" target="_blank"
              >Unmatched</a
            >
            is a board game from
            <a href="https://restorationgames.com/" target="_blank"
              >Restoration Games</a
            >
            and
            <a href="https://mondotees.com/" target="_blank">Mondo Games</a>
            where players control various iconic characters in combat against
            each other. Each character has their own deck with a unique fighting
            style.
          </p>
          <p>
            Of course, the more heroes there are to choose from, the more fun
            the game becomes. Unmatched Maker is a place for fans to create and
            share their own character decks.
          </p>
          <p>
            Join the Unmatched Maker community! For feedback, bug reports,
            feature requests, or just to talk about Unmatched, please
            <router-link :to="{ name: 'Contact' }">get in touch</router-link>.
          </p>
        </div>
      </b-col>
      <b-col lg="8" order-lg="1">
        <div class="site-features">
          <h2>Features</h2>
          <dl class="row">
            <dt class="col-sm-3">
              <router-link :to="{ name: 'DeckList' }">Fan decks</router-link>
            </dt>
            <dd class="col-sm-9">
              Browse and search fan decks that others have created and shared.
              <MatchupCount
                :officialDeckCount="officialDeckCount"
                :fanDeckCount="fanDeckCount"
              />
            </dd>

            <dt class="col-sm-3">
              <router-link :to="{ name: 'CreateDeck' }"
                >Create deck</router-link
              >
            </dt>
            <dd class="col-sm-9">
              Create your own decks, save them to your account, publish publicly
              or share privately, print, or export them to an image file.
            </dd>

            <dt class="col-sm-3">
              <router-link :to="{ name: 'UmDb' }"
                >Unmatched database (UmDb)</router-link
              >
            </dt>
            <dd class="col-sm-9">
              Information about published and upcoming
              <router-link :to="{ name: 'UmDbSetList' }">sets</router-link>,
              <router-link :to="{ name: 'UmDbDeckList' }">decks</router-link>
              (including
              <router-link :to="{ name: 'UmDbDeckStats' }"
                >deck statistics</router-link
              >), and a searchable, sortable
              <router-link :to="{ name: 'UmDbCardList' }"
                >card listing</router-link
              >.
            </dd>

            <dt class="col-sm-3">
              <router-link :to="{ name: 'TrackGame' }">Track games</router-link>
            </dt>
            <dd class="col-sm-9">
              Record your games played, including notes and ratings. Hone your
              own decks, help others balance theirs, and contribute to site-wide
              and personal results stats. <em>(Login required)</em>
            </dd>

            <dt class="col-sm-3">
              <router-link :to="{ name: 'ResultsGrid' }">Results</router-link>
            </dt>
            <dd class="col-sm-9">
              View win/loss records for all of the official character match-ups.
            </dd>

            <dt class="col-sm-3">
              <router-link :to="{ name: 'Resources' }"
                >External resources</router-link
              >
            </dt>
            <dd class="col-sm-9">
              Links to other sites related to Unmatched, both official and
              unofficial.
            </dd>
          </dl>
        </div>
      </b-col>
    </b-row>
    <h2>News</h2>
    <NewsWidgetResponsive
      :newsPosts="newsPosts"
      :newsPostCount="newsPostCount"
      cols="1"
      cols-md="2"
      cols-lg="3"
      breakpoint="md"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import MatchupCount from "@/components/MatchupCount.vue";
import NewsWidgetResponsive from "@/components/NewsWidgetResponsive.vue";

import api from "@/api.js";

export default {
  name: "Welcome",
  metaInfo: {
    title: "Home",
  },
  data() {
    return {
      newsPostCount: parseInt(process.env.VUE_APP_POSTS_ON_HOMEPAGE) || 6,
    };
  },
  components: { MatchupCount, NewsWidgetResponsive },
  computed: {
    officialDeckCount() {
      return this.$store.state.umDbDeckList.filter(
        (deck) => deck.cards.length > 0
      ).length;
    },
    fanDeckCount() {
      return this.$store.state.fanDeckCount || 0;
    },
  },
  asyncComputed: {
    async newsPosts() {
      const data = await api.getPosts({ perPage: this.newsPostCount });
      return data.posts;
    },
  },
};
</script>

<style lang="scss">
.welcome {
  .news-post.card {
    height: 28em;
    overflow: scroll;
  }
}
</style>
